import { render, staticRenderFns } from "./NeracaSimple.vue?vue&type=template&id=7ffd293f&scoped=true&"
import script from "./NeracaSimple.vue?vue&type=script&lang=js&"
export * from "./NeracaSimple.vue?vue&type=script&lang=js&"
import style0 from "./NeracaSimple.vue?vue&type=style&index=0&id=7ffd293f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd293f",
  null
  
)

export default component.exports